module.exports = __webpack_public_path__ + "static/img/Macadamia.116913d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Macadamia.jpg
// module id = 2LrS
// module chunks = 0